import React, { useMemo } from "react";
import ContactA4H from "../Contact/ContactA4H";

/* ---------- Donation Button Card ---------- */
function DonationCard({
  title = "Support Our Mission",
  desc,
  href = "https://givebutter.com/Nnf9Vr",
}) {
  // If you ever switch back to a button click, this won't crash in SSR:
  const safeNavigate = () => {
    if (typeof window !== "undefined" && href) {
      window.open(href, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="about-donateCard" role="region" aria-label="Donation">
      <h4 className="about-donateTitle">{title}</h4>
      {desc ? <p className="about-donateDesc">{desc}</p> : null}

      <div className="fog-action-buttons">
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="fog-btn"
        >
          Donate
        </a>
      </div>

      {/* If you prefer a button instead of an anchor, use the safe handler:
      <button type="button" className="about-donateBtn" onClick={safeNavigate}>
        Donate / Sponsor <span className="about-donateArrow" aria-hidden>→</span>
      </button>
      */}
    </div>
  );
}

/* ---------- Section Card ---------- */
function AboutSection({ title, children }) {
  return (
    <div className="row about-section-row">
      <div className="col-12">
        <div className="about-card about-div-text">
          {title ? <h3 className="white mb-2">{title}</h3> : null}
          {children}
        </div>
      </div>
    </div>
  );
}

const nationalTeam = [
  ["Alabama", "Dr. Subir Paul", "President"],
  ["Arizona", "Manish Gupta", "President"], ["Arizona", "Shamini Oza-Shah", "Vice President"],
  ["Arkansas", "Dr. Srini Vengala", "President"], ["California", "Dr. Romesh K Japra", "Founder & Chairman"],
  ["California", "Jyotsna Vijaya Lakshmi Sharma", "National Vice President"], ["California", "Ritu Maheshwari", "Executive Vice President"],
  ["California", "Dr. Abhilash Maroju", "Associate Director"], ["California", "Neeraj Kashalkar", "President (Southern California)"],
  ["California", "Geeta Sikand", "Vice President, Communications"], ["California", "Sartaj Singh Sekhon", "President (Sacramento)"],
  ["California", "KP Maheshwari", "Chief Financial Officer (CFO)"], ["California", "Navneet J. Pathak", "Chief Organization Officer (COO)"],
  ["Colorado", "Hemal Trivedi", "President"], ["Colorado", "Janak Joshi", "Chair and Chief Advisor"],
  ["Connecticut", "Bharvi Parikh", "President"], ["Connecticut", "Sheetal Parikh", "Chief Advisor"],
  ["Delaware", "Thirumal Reddy Hanumapur", "President"], ["Florida", "Dr. Pawan Rattan", "Chief Advisor"],
  ["Florida", "Dr. Rakesh Sharma", "President"], ["Florida", "Sanjeev Kumar", "Vice President"],
  ["Illinois", "Amar Upadhyay", "President"], ["Louisiana", "Dr. Surendra Purohit", "President"],
  ["Maine", "Dr. Krishna Bhatta", "President"], ["Maryland", "Dr. Raman Sood", "Executive Director"],
  ["Maryland", "Vidya Mishra", "President"], ["Massachusetts", "Pramit Makoday", "Global President"],
  ["Massachusetts", "Dr. Lakshmi Thalanki", "President"], ["Michigan", "Pramod Thanedar", "President"],
  ["Michigan", "Hema Rachmale", "Vice President"], ["Michigan", "Ashok Baddi", "National Ambassador"],
  ["Michigan", "Dr. Ajith Kadakol", "Membership Chair Michigan"], ["Michigan", "Anand Sinha", "Chief Information Officer (CIO) & Social Media Chair"],
  ["Missouri", "Dr. Raghuveer Kura", "President"], ["Missouri", "Dev Bharwad", "Treasurer"],
  ["Nevada", "Samita Sood", "Executive Director"], ["Nevada", "Rajat Sood", "President"],
  ["New Hampshire", "Janmejay Sanatani (Jjay)", "President"], ["New Jersey", "Falguni Pandya", "President"],
  ["New Mexico", "Rinita Mazumdar", "President"], ["New York", "Dr. Rakesh Shridar", "President"],
  ["New York", "Monolita Mitra", "Vice President"], ["North Carolina", "Aditya Ahlawat", "President"],
  ["North Carolina", "Abhijit Bagal", "Vice President"], ["Ohio", "Niranjan Neil Patel", "President"],
  ["Ohio", "Andy Vasani", "Vice President"], ["Pensylvania", "Avanish Raj", "President"],
  ["Rhode Island", "Pradeep Sharma", "President"], ["Sacramento", "Jaimin Upadhyay", "National Vice President Outreach"],
  ["Tennessee", "Jyothi Pinnaka", "President"], ["Texas", "Ajay Aggarwal", "President"],
  ["Texas", "Paro Sarkar", "Communications VP"], ["Texas", "Sreedhar Bendapudi", "Vice President"],
  ["Utah", "Satya Bathula", "President"], ["Virginia", "Madhu Govil", "Executive Director"],
  ["Virginia", "Akhil Govil", "President"], ["Washington", "Prasad Anguluri", "President"],
  ["Washington", "Prashant Sriperambudhuru", "Vice President"], ["Washington D.C.", "Rajiv Sharma", "National President"],
];

function NationalTeam() {
  return (
    <section className="national-team-section" aria-labelledby="national-team-title">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-9">
            {/*<div className="national-team-heading">
              
              <h2 id="national-team-title">a4h team</h2>
              
            </div>
            <div className="national-team-list" role="list">
              {nationalTeam.map(([state, name, position]) => {
                const isPresident =
  position.toLowerCase().includes("president") &&
  !position.toLowerCase().includes("vice president");
                return (
                  <article className={`national-team-member${isPresident ? " is-president" : ""}`} role="listitem" key={`${state}-${name}`}>
                    <span className="national-team-state">{state}</span>
                    <span className="national-team-name">{name}</span>
                    <span className="national-team-role">{position}</span>
                  </article>
                );
              })}
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

function AboutUs() {
  const donationLine =
    "Preserve culture. Build leaders. Empower our future — support our mission today.";

  const sections = useMemo(
    () => [
      {
        key: "intro",
        title: "Introduction",
        content: (
          <>
            <p className="white">
             Americans4Hindus (A4H) and Festival of Globe (FOG) together form a unified national
              platform dedicated to cultural celebration, community empowerment, civic education,
              and political representation for Hindu Americans.
            </p>
            <p className="white">
              Through our combined programs, we nurture leadership across generations, strengthen
              identity, promote wellness, and advance meaningful civic and policy engagement
              nationwide.
            </p>
          </>
        ),
      },
      {
        key: "mission",
        title: "Our Mission",
        content: (
          <p className="white">
            To celebrate the richness of the Hindu way of life while cultivating leadership,
            empowering communities, and strengthening civic, educational, and political engagement
            for Hindu Americans and pro-Hindu allies.
          </p>
        ),
      },
      {
        key: "vision",
        title: "Our Vision",
        content: (
          <p className="white">
            A united, empowered community leading with knowledge, compassion, culture, and public
            service shaping a strong national presence for generations to come.
          </p>
        ),
      },
      {
        key: "focus-areas",
        title: "The Six Guiding Focus Areas of Our Work",
        content: (
          <ol className="white arrow-list about-ol">
            <li>
              <strong>Voter Education Academy</strong>
              <div>
                Providing structured, nonpartisan civic learning resources, workshops, and guides
                that teach community members how elections work, how to interpret ballots, and how
                to participate confidently.
              </div>
            </li>
            <li>
              <strong>Voter Empowerment &amp; Mobilization</strong>
              <div>
                Driving community turnout through registration campaigns, local chapter organizing,
                youth mobilization, and coordinated GOTV efforts.
              </div>
            </li>
            <li>
              <strong>Political &amp; Policy Awareness</strong>
              <div>
                Offering policy briefings, candidate scorecards, issue education, and public forums
                to help the community understand local and national decisions that impact Hindu
                Americans.
              </div>
            </li>
            <li>
              <strong>Leadership Development &amp; Civic Engagement</strong>
              <div>
                Building leadership pipelines through youth programs, women’s leadership circles,
                Rajneeti Academy courses, internships, public speaking workshops, and mentorship
                networks.
              </div>
            </li>
            <li>
              <strong>Digital &amp; Media Engagement for Political Awareness</strong>
              <div>
                Producing media content, newsletters, video explainers, and narrative-building
                campaigns to ensure the community receives accurate information and gains
                representation in public discourse.
              </div>
            </li>
            <li>
              <strong>Community Service &amp; Civic Responsibility</strong>
              <div>
                Organizing health fairs, food drives, interfaith collaborations, community
                volunteering, and wellness initiatives inspired by the values of Seva and Ahimsa.
              </div>
            </li>
          </ol>
        ),
      },
      {
        key: "structure",
        title: "Our Structure",
        content: (
          <ul className="white arrow-list">
            <li>
              <h4 className="white mt-2">
                <b>Americans4Hindus PAC - Political Action Committee </b>
              </h4>
              <ul className="white dot-list">
                <li>A4H PAC (Political Action Committee)</li>
                <li>A4H Voter Guide</li>
                <li>A4H Endorsed Candidates </li>
                <li>A4H Multiple State PACS (38 Chapters)</li>
                <li>A4H Press Releases </li>
              </ul>
            </li>

            <li>
              <h4 className="white mt-3">
                <b>Americans4Hindus - 501(C)(3) - Non Profit Organization</b>
              </h4>
              <ul className="white dot-list">
                <li>Hindu Way of Living (Duty towards Dharma)</li>
                <li>Hindu Rajneeti Academy (Leadership Development)</li>
                <li>Alliances & Coalitions (Interfaith, Ethnicities, Nations)</li>
                <li>Hindu Buddhist Sikh Jain (HBSJ) American Congressional Caucus</li>
                <li>A4H Temple Rakshak</li>
                <li>A4H Temple Rakshak</li>
                
              </ul>
            </li>
            <li>
              <h4 className="white mt-3">
                <b>Americans4Hindus - 501(C)(4) DAC (Dharma Action Council)</b>
              </h4>
              <ul className="white dot-list">
                <li>Legislative lobbying </li>
                <li>Grassroots Advocacy </li>
                <li>Government Relations Program </li>
                <li>Issue-Based Campaigns (Non-Electoral)</li>
                <li>Public Policy Communications</li>
                <li>Research-to-Advocacy Pipeline</li>
                <li>Membership-Based Advocacy Infrastructure</li>
                
              </ul>
            </li>
            <li>
              <h4 className="white mt-3"><strong>FESTIVAL OF GLOBE – NON PROFIT ORGANIZATION – 501 (C)(3)</strong></h4>
              <ul className="white dot-list">
                <li>FOG Community Services</li>
                <li>FOG Annual Festivals & Programs</li>
                <li>FOG Annual India Day Parade & Fair (Mela)</li>
                <li>FOG Proclamations & Recognitions</li>
                
              </ul>
            </li>
          </ul>
        ),
      },
      {
        key: "founder",
        title: "Our Founder",
        content: (
          <>
            <h4 className="white mt-2 uppercase">
              <b>Dr. Romesh K. Japra</b>
            </h4>
            <p className="white mt-2">
              Dr. Romesh K. Japra is a highly respected cardiologist at Washington Hospital in
              Fremont, California, widely recognized for his decades of service marked by medical
              excellence, compassion, and integrity. Alongside his distinguished career in
              healthcare, he has emerged as a visionary community leader whose work has
              significantly shaped the cultural and civic landscape of the Bay Area.
            </p>
            <p className="white mt-2">
              In 1985, Dr. Japra founded the <b>Fremont Hindu Temple</b>, which under his
              leadership has grown into one of the region’s most prominent spiritual and cultural
              institutions. The temple has played a vital role in preserving Hindu traditions,
              values, and dharma while serving as a unifying center for education, service, and
              celebration across generations. His commitment to cultural continuity and community
              building has been central to the temple’s enduring impact.
            </p>
            <p className="white mt-2">
              Building on this foundation, Dr. Japra established the <b>Festival of Globe</b> in
              1993, a respected nonprofit organization best known for organizing the largest India
              Day Parade in the United States, along with numerous cultural and community
              initiatives. These efforts have received widespread recognition and official
              proclamations from cities and counties throughout the Bay Area. In response to the
              evolving needs of the community, he also founded <b>Americans4Hindus (A4H)</b> in
              2023, a non-partisan political action committee dedicated to civic engagement, policy
              awareness, and representation reflecting his forward-looking leadership and lifelong
              commitment to service.
            </p>
          </>
        ),
      },
      {
        key: "values",
        title: "Our Values",
        content: (
          <p className="white">
            Dharma • Seva • Ahimsa • Karma • Vasudhaiva Kutumbakam • Pluralism
          </p>
        ),
      },
      
    ],
    [donationLine]
  );

  return (
    <>
      <style>{`
        :root{
          --about-fill: 11 58 150;
          --about-fill-alpha: 0.35;
        }

        html, body { overflow-x: hidden; }

        .block.color-scheme-4{ padding-left:0!important; padding-right:0!important; overflow-x:hidden; }
        .about-service-page .block.color-scheme-4{
          padding-top:52px!important;
          padding-bottom:34px!important;
        }
        .about-service-page #contact .block{
          padding-top:44px!important;
          padding-bottom:34px!important;
        }
        .about-service-page #contact .section-sub-title .head-title{
          padding-bottom:20px!important;
          margin-bottom:20px!important;
        }
        .about-topWrap{ max-width:980px; margin:0 auto 6px; padding:4px 6px 0; text-align:center; }
        .about-topTitle{ margin:0; line-height:1.1; font-size:clamp(28px,4vw,44px); font-weight:800; letter-spacing:0.01em; }
        .about-topSubtitle{ margin:6px auto 0; max-width:860px; opacity:.96; font-size:16px; line-height:1.45; }

        .about-card{ border-radius:18px; overflow:hidden; background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.12); position:relative; }
        .about-div-text{ padding:14px; text-align:left; }

        .about-section-row{
          margin-top:12px!important;
          --bs-gutter-x:0;
          --bs-gutter-y:0;
        }
        .section-title-body > .about-section-row:first-child{
          margin-top:0!important;
        }
        .about-card h3{
          margin-bottom:6px!important;
        }

        .about-after-content p,
        .about-after-content li,
        .about-after-content ul,
        .about-after-content ol,
        .about-after-content span,
        .about-after-content div { color:#000 !important; }

        .about-ol{ padding-left: 18px; }
        .about-ol li{ margin-bottom: 10px; }
        .about-ol li strong{ display:block; margin-bottom: 4px; }

        .about-card .mt-2{ margin-top:.45rem!important; }
        .about-card .mt-3{ margin-top:.65rem!important; }
        .about-card p{ margin-bottom:.65rem!important; }
        .about-card p:last-child,
        .about-card ul:last-child,
        .about-card ol:last-child{ margin-bottom:0!important; }

        .national-team-section{
          padding:58px 0 64px;
          background:transparent !important;
          color:inherit;
        }
        .national-team-heading{
  text-align:left;
  margin:0 0 26px;
  max-width:100%;
}
        .national-team-kicker{ display:block; margin-bottom:6px; color:#b28527; font-size:12px; font-weight:800; letter-spacing:.14em; text-transform:uppercase; }
        .national-team-heading h2{ margin:0; color:#102a5a; font-size:clamp(30px,4vw,42px); font-weight:800; line-height:1.08; }
        .national-team-heading p{ margin:10px 0 0; color:#52627d; font-size:16px; line-height:1.5; }
        .national-team-list{
  overflow:hidden;
  border:1px solid rgba(255,255,255,.15);
  border-radius:18px;
  background:rgba(255,255,255,.06);
  box-shadow:0 8px 24px rgba(0,0,0,.12);
}
        .national-team-member{ display:grid; grid-template-columns:minmax(118px,.78fr) minmax(180px,1.15fr) minmax(190px,1.35fr); align-items:center; gap:18px; min-height:62px; padding:13px 22px; border-bottom:1px solid #e8edf5; transition:background .2s ease, transform .2s ease; }
        .national-team-member:last-child{ border-bottom:0; }
        .national-team-member:hover{ background:#f5f8ff; }
        .national-team-state{ color:#77859d; font-size:15px; font-weight:800; letter-spacing:.03em; }
        .national-team-name{ color:#172b4d; font-size:19px; font-weight:700; line-height:1.4; }
        .national-team-role{ color:#435779; font-size:17px; font-weight:600; line-height:1.4; }
        .national-team-member.is-president{ background:linear-gradient(90deg, rgba(218,184,87,.13), rgba(255,255,255,0) 72%); }
        .national-team-member.is-president .national-team-name{ color:#0c2860; font-size:20px; }
        .national-team-member.is-president .national-team-role{ color:#9b741e; font-size:17px; font-weight:800; }

        .about-donateCard{
          background:#fff;
          border:1px solid rgba(0,0,0,.12);
          border-radius:22px;
          padding:22px;
          box-shadow:0 8px 24px rgba(0,0,0,.08);
          text-align:left;
        }
        .about-donateTitle{
          margin:0 0 8px 0;
          font-weight:800;
          font-size:22px;
          color:#0e1a2b;
          letter-spacing:.2px;
        }
        .about-donateDesc{
          margin:0 0 16px 0;
          color:#1e2430;
          line-height:1.55;
        }

        .dot-list {
  list-style-type: disc;
  padding-left: 18px;   /* reduced from 25px */
  margin-top: 6px;
}

.dot-list li {
  display: list-item;
  list-style-position: outside;
  margin-bottom: 5px;
  padding-left: 2px;    /* keeps text closer to dot */
}

.dot-list li::before {
  content: none !important;

}
.section-divider{
  width:100%;
  max-width:900px;
  margin:10px auto 12px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:12px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:2px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}

@media (max-width: 768px) {
  .about-service-page .block.color-scheme-4{
    padding-top:32px!important;
    padding-bottom:22px!important;
  }

  .about-service-page #contact .block{
    padding-top:32px!important;
    padding-bottom:24px!important;
  }

  .about-service-page #contact .section-sub-title .head-title{
    padding-bottom:14px!important;
    margin-bottom:16px!important;
  }

  .about-topWrap{
    margin-bottom:4px;
    padding-top:0;
  }

  .about-topTitle{
    font-size:24px !important;
    line-height:1.1 !important;
  }

  .about-topSubtitle{
    font-size:13px !important;
    line-height:1.4 !important;
  }

  .about-section-row{
    margin-top:8px!important;
  }

  .about-div-text{
    padding:12px;
  }

  .about-card h3{
    font-size:18px !important;
    line-height:1.2 !important;
  }

  .about-card h4,
  .about-donateTitle{
    font-size:14px !important;
    line-height:1.25 !important;
  }

  .about-after-content p,
  .about-after-content li,
  .about-after-content div,
  .about-donateDesc{
    font-size:13px !important;
    line-height:1.4 !important;
  }

  .section-divider span{
    font-size:16px;
  }

  .section-divider{
    margin:8px auto 10px;
    gap:8px;
  }

  .national-team-section{ padding:38px 0 42px; }
  .national-team-heading{ margin-bottom:20px; padding:0 12px; }
  .national-team-heading h2{ font-size:28px; }
  .national-team-heading p{ font-size:14px; }
  .national-team-member{ grid-template-columns:1fr; gap:3px; min-height:0; padding:14px 16px; }
  .national-team-state{ font-size:11px; text-transform:uppercase; }
  .national-team-name{ font-size:15px; }
  .national-team-role{ font-size:13px; }
  .national-team-member.is-president .national-team-name{ font-size:16px; }
  .national-team-member.is-president .national-team-role{ font-size:14px; }

  .about-ol li,
  .dot-list li{
    margin-bottom:6px;
  }
}
      `}</style>

      <div className="about-service-page">
      <section>
        <div className="block color-scheme-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="about-topWrap">
                  <h1 className="about-topTitle white head-title">
                    <span className="uppercase">ABOUT US</span>
                  </h1>
                  <div className="section-divider">
            <span>✦ ✦ ✦</span>
          </div>
                  <p className="about-topSubtitle white">
                    <strong>Who We Are &amp; What We Stand For</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-after-content">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-10 col-lg-9">
                  <article className="section-title-body">
                    {sections.map((s) => (
                      <AboutSection key={s.key} title={s.title}>
                        {s.content}
                      </AboutSection>
                    ))}
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <NationalTeam />

      <section>
        <ContactA4H />
      </section>
      </div>
    </>
  );
}

export default AboutUs;
